import { ActionTypes, FaultCodeMappingActions } from './fault-code-mapping.actions';
import { FaultCodeMappingState } from './fault-code-mapping.model';

export const faultCodeMappingState: FaultCodeMappingState = {
  tableDataLoading: false,
  tableDataLoaded: false,
  tableData: [],
  tablePageInfo: {
    page: 1,
    pageCount: 0,
    total: 0,
  },
  getFaultCodeMappingLoading: false,
  getFaultCodeMappingLoaded: false,
  faultCodeMapping: null,
  addFaultCodeMappingLoading: false,
  addFaultCodeMappingLoaded: false,
  editFaultCodeMappingLoading: false,
  editFaultCodeMappingLoaded: false,
  deleteFaultCodeMappingsLoading: false,
  deleteFaultCodeMappingsLoaded: false,
  activitiesDataLoading: false,
  activitiesDataLoaded: false,
  activitiesData: [],
  tasksDataLoading: false,
  tasksDataLoaded: false,
  tasksData: [],
  taskLookupDataLoading: false,
  taskLookupDataLoaded: false,
  taskLookupData: [],
};

export function faultCodeMappingReducer(
  state: FaultCodeMappingState = faultCodeMappingState,
  action: FaultCodeMappingActions,
): FaultCodeMappingState {
  switch (action.type) {
    case ActionTypes.FAULT_CODE_MAPPINGS_DATA_LOADING:
      return {
        ...state,
        tableDataLoading: true,
        tableDataLoaded: false,
      };
    case ActionTypes.FAULT_CODE_MAPPINGS_DATA_LOADED:
      return {
        ...state,
        tableData: action.payload.data,
        tablePageInfo: {
          page: action.payload.page,
          pageCount: action.payload.pageCount,
          total: action.payload.total,
        },
        tableDataLoading: false,
        tableDataLoaded: true,
      };
    case ActionTypes.GET_FAULT_CODE_MAPPING:
      return {
        ...state,
        getFaultCodeMappingLoading: true,
        getFaultCodeMappingLoaded: false,
      };
    case ActionTypes.GET_FAULT_CODE_MAPPING_COMPLETED:
      return {
        ...state,
        faultCodeMapping: action.payload.data,
        getFaultCodeMappingLoading: false,
        getFaultCodeMappingLoaded: true,
      };
    case ActionTypes.ADD_FAULT_CODE_MAPPING:
      return {
        ...state,
        addFaultCodeMappingLoading: true,
        addFaultCodeMappingLoaded: false,
      };
    case ActionTypes.ADD_FAULT_CODE_MAPPING_COMPLETED:
      return {
        ...state,
        addFaultCodeMappingLoading: false,
        addFaultCodeMappingLoaded: true,
      };
    case ActionTypes.EDIT_FAULT_CODE_MAPPING:
      return {
        ...state,
        editFaultCodeMappingLoading: true,
        editFaultCodeMappingLoaded: false,
      };
    case ActionTypes.EDIT_FAULT_CODE_MAPPING_COMPLETED:
      return {
        ...state,
        editFaultCodeMappingLoading: false,
        editFaultCodeMappingLoaded: true,
      };
    case ActionTypes.DELETE_FAULT_CODE_MAPPINGS:
      return {
        ...state,
        deleteFaultCodeMappingsLoading: true,
        deleteFaultCodeMappingsLoaded: false,
      };
    case ActionTypes.DELETE_FAULT_CODE_MAPPINGS_COMPLETED:
      return {
        ...state,
        deleteFaultCodeMappingsLoading: false,
        deleteFaultCodeMappingsLoaded: true,
      };
    case ActionTypes.ACTIVITIES_DATA_LOADING:
      return {
        ...state,
        activitiesDataLoading: true,
        activitiesDataLoaded: false,
      };
    case ActionTypes.ACTIVITIES_DATA_COMPLETED:
      return {
        ...state,
        activitiesData: action.payload,
        activitiesDataLoading: false,
        activitiesDataLoaded: true,
      };
    case ActionTypes.TASKS_DATA_LOADING:
      return {
        ...state,
        tasksDataLoading: true,
        tasksDataLoaded: false,
      };
    case ActionTypes.TASKS_DATA_COMPLETED:
      return {
        ...state,
        tasksData: action.payload,
        tasksDataLoading: false,
        tasksDataLoaded: true,
      };
    case ActionTypes.TASK_LOOKUP_DATA_LOADING:
      return {
        ...state,
        taskLookupDataLoading: true,
        taskLookupDataLoaded: false,
      };
    case ActionTypes.TASK_LOOKUP_DATA_COMPLETED:
      return {
        ...state,
        taskLookupData: action.payload,
        taskLookupDataLoading: false,
        taskLookupDataLoaded: true,
      };
    case ActionTypes.FETCH_ERROR:
      return {
        ...state,
      };
    default:
      return state;
  }
}
